import { Box, Button, Flex, Icon } from '@chakra-ui/react';
import NavigationMenu from './NavigationMenu';
import OrgSwitcher from './OrgSwitcher';
import { useAuth } from '@/context/AuthProvider';
import { BiCog, BiLogOut } from 'react-icons/bi';
import { MdAdminPanelSettings } from 'react-icons/md';
import NavItem from './NavItem';
import { useIsSuperuser, useUserQuery } from '@/api/user/useUserQuery';
import { useTranslation } from 'react-i18next';

function Sidebar() {
  const { logout } = useAuth();
  const isSuperuser = useIsSuperuser();
  const { data: user } = useUserQuery();
  const { t } = useTranslation('common');
  const hasOrganization =
    user?.organization !== null && user?.organization !== undefined;

  return (
    <>
      {/* Desktop Sidebar */}
      <Box
        display={{ base: 'none', lg: 'block' }}
        w="240px"
        h="100vh"
        borderRight="1px solid"
        borderColor="gray.200"
        position="fixed"
        top={0}
        left={0}
        zIndex="sidebar"
        overflowY="auto"
        bg="gray.800"
      >
        <Flex
          pt={4}
          pb={4}
          px={4}
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
        >
          <Flex flexDirection="column" gap={4}>
            {hasOrganization && <OrgSwitcher />}
            {hasOrganization && <NavigationMenu />}
          </Flex>
          {/* Bottom section */}
          <Flex flexDirection="column" gap={2}>
            {isSuperuser && (
              <NavItem
                key="admin"
                to="/admin"
                icon={MdAdminPanelSettings}
                isActive={location.pathname === '/admin'}
              >
                Admin
              </NavItem>
            )}
            <NavItem
              key="settings"
              to="/settings"
              icon={BiCog}
              isActive={location.pathname === '/settings'}
            >
              {t('settings')}
            </NavItem>
            <Button
              variant="ghost"
              onClick={() => logout()}
              w="full"
              justifyContent="flex-start"
              color="white"
              _hover={{
                bg: 'gray.700',
              }}
            >
              <Icon as={BiLogOut} mr={3} boxSize={5} />
              {t('logout')}
            </Button>
          </Flex>
        </Flex>
      </Box>
    </>
  );
}

export default Sidebar;
